
    export default 
    {
    "footer": {
        "about": "Su di noi",
        "support": "Supporto",
        "privacy_policy": "Politica sulla privacy"
    }
}